import * as actions from './appActions';

const appReducers = {
  [actions.APP_STORE_BASIC_INFO]: (state, { payload }) => {
    state.basicInfo = payload;
    return state;
  },
  [actions.APP_CLEAR_BASIC_INFO]: state => {
    delete state.basicInfo;
    return state;
  },
  [actions.APP_STORE_FULL_PROFILE]: (state, { payload }) => {
    state.fullProfile = payload;
    return state;
  },
  [actions.APP_CLEAR_FULL_PROFILE]: state => {
    delete state.fullProfile;
    return state;
  },
  [actions.APP_CLEAR_APP_DATA]: () => ({}),
  [actions.APP_SET_DASHBOARD_HISTORY_TAB]: (state, { payload }) => {
    return { ...state, dashboardHistoryTab: payload };
  },
};

export default {
  name: 'app',
  reducers: appReducers,
};
